const API_URL = process.env.REACT_APP_API_URL;

const config = {
  API_URL,
  // commerce-api vive tras el gateway (Tyk) en /v1/commerce. Se deriva del base
  // en vez de una env var propia: mismo host, distinto listen_path. Se puede
  // sobreescribir con REACT_APP_ORDERS_API_URL para apuntar a un commerce local.
  ORDERS_API_URL:
    process.env.REACT_APP_ORDERS_API_URL || `${API_URL}/v1/commerce`,
  // hap-graph vive tras el gateway en /graphql. Se deriva del base y se
  // puede sobreescribir con REACT_APP_HAP_GRAPH_URL para apuntar a uno local.
  HAP_GRAPH_URL: process.env.REACT_APP_HAP_GRAPH_URL || `${API_URL}/graphql`,
  KEYCLOAK_URL: process.env.REACT_APP_KEYCLOAK_URL,
  KEYCLOAK_REALM: 'happify',
  KEYCLOAK_CLIENT_ID: 'happify-admin-website',
  KEYCLOAK_REFRESH_MIN_VALIDITY: 5,
  USER_NAME: `${process.env.REACT_APP_KEYCLOAK_URL}/realms/happify/protocol/openid-connect/userinfo`,
  VERSION: process.env.REACT_APP_VERSION,
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
};

export default config;
